import React from "react";
import { Icon } from "antd";

const LandingSvg: React.FC = () => (
  <svg width="1em" height="1em" viewBox="0 0 512.004 512.004">
    <g>
      <path
        d="M510.392,225.689c-3.271-11.287-11.062-20.718-21.937-26.55c-4.625-2.486-9.646-4.207-14.917-5.126L106.77,130.526
				L73.52,69.457c-2.396-4.401-7.854-6.519-12.896-4.923l-32,9.904c-4.729,1.461-7.729,5.774-7.229,10.378l10.667,99.042
				c0.438,4.111,3.583,7.534,7.896,8.589l183.561,44.859l-91.999,76.864c-3.042,2.544-4.229,6.48-3.104,10.127
				c1.146,3.646,4.438,6.364,8.479,7.003l63.249,9.904c0.583,0.087,1.188,0.135,1.771,0.135c1.833,0,3.667-0.445,5.271-1.296
        l146.645-77.415l100.958,18.271c19.937,3.801,40.083-4.652,50.875-22.033C511.954,248.757,513.642,236.967,510.392,225.689z"
        fill="currentColor"
      />
      <path
        d="M352,405.337H10.667C4.771,405.337,0,410.108,0,416.004v21.333c0,5.896,4.771,10.667,10.667,10.667H352
        c5.896,0,10.667-4.771,10.667-10.667v-21.333C362.667,410.108,357.896,405.337,352,405.337z"
        fill="currentColor"
      />
    </g>
  </svg>
);

const LandingIcon: React.FC = props => (
  <Icon component={LandingSvg} {...props}></Icon>
);

export default LandingIcon;
